import { User } from '@src/main/modules/common/user/domain/User';

export interface UserResponse {
  id: string;
  name: string;
  recentlyOpened: string[];
  favorites: string[];
  recommended: string[];
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  roles: string[];
}

export const mapFromResponseToDomain = (userResponse: UserResponse): User => ({
  ...userResponse,
  createdAt: new Date(Date.parse(userResponse.createdAt)),
  updatedAt: new Date(Date.parse(userResponse.updatedAt)),
});
